/**
 * Domain utilities for multi-domain platform
 * Handles dynamic default domain selection and domain management
 */

/**
 * Get the default domain for short links
 * Priority: First verified domain > First domain > fallback
 */
export const getDefaultDomain = (domains = []) => {
  if (!domains || domains.length === 0) {
    // Fallback when no domains are configured
    return process.env.REACT_APP_DEFAULT_DOMAIN || 'example.com';
  }

  // Find first verified domain
  const verifiedDomain = domains.find(d => d.isVerified);
  if (verifiedDomain) {
    return verifiedDomain.domain;
  }

  // Fallback to first domain (even if not verified)
  return domains[0].domain;
};

/**
 * Get domain name for a link
 * Uses the link's domain or falls back to default
 */
export const getLinkDomain = (link, domains = []) => {
  if (link.domainId) {
    const domain = domains.find(d => d.id === link.domainId);
    if (domain) {
      return domain.domain;
    }
  }

  // Use stored domain name if available
  if (link.domain) {
    return link.domain;
  }

  // Fallback to default domain
  return getDefaultDomain(domains);
};

/**
 * Build full short URL for a link
 */
export const buildShortUrl = (shortCode, domainName) => {
  return `https://${domainName}/${shortCode}`;
};

/**
 * Get available domains for selection
 */
export const getAvailableDomains = (domains = []) => {
  // Get default domain info
  const defaultDomain = getDefaultDomain(domains);

  // Filter for verified domains
  const verifiedDomains = domains.filter(d => d.isVerified);

  return {
    defaultDomain,
    verifiedDomains,
    allDomains: domains
  };
};

/**
 * Format domain for display in dropdowns
 */
export const formatDomainOption = (domain, isDefault = false) => {
  const label = isDefault ? `${domain} (default)` : domain;
  return { value: '', label, domain };
};